import React from "react";
import {Container, Header} from "semantic-ui-react";

export default () => {
    return (
        <Container textAlign="center">
            <Header as="h1">404</Header>
        </Container>
    );
};